import { useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { TabMenu } from "@/components/TabMenu";
import { TATStatusLegend } from "@/components/TATStatusLegend";
import { RoomList } from "@/components/RoomList";
import { PatientListView } from "@/components/PatientListView";
import { PatientTimeline } from "@/components/PatientTimeline";
import { TentativeDischargeView } from "@/components/TentativeDischargeView";

const validTabs = ["board", "list", "timeline", "tentative"];

const Index = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab = tabParam && validTabs.includes(tabParam) ? tabParam : "board";

  const setActiveTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <TabMenu activeTab={activeTab} onTabChange={setActiveTab} />
      <TATStatusLegend />
      <div className="pb-2 sm:pb-3">
        {activeTab === "board" && <RoomList />}
        {activeTab === "list" && <PatientListView />}
        {activeTab === "timeline" && <PatientTimeline />}
        {activeTab === "tentative" && <TentativeDischargeView />}
      </div>
    </div>
  );
};

export default Index;
